import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CardItem from "../../common/card/card";
import getCard from "../../common/drawCard/getCard";

function CardRight() {
  const chosenCard = useSelector((state) => state.rightPlayer.chosenCard);
  const { show, suit, card } = chosenCard;

  useEffect(() => {
    getCard("rightcard", "card_right");
  }, [chosenCard]);
  return show ? (
    <div id="rightcard">
      <CardItem suit={suit} card={card} downCard="card_right" />
    </div>
  ) : (
    <div id="rightcard"></div>
  );
}

export default CardRight;
